import React from 'react';

export interface AuthInviteBadgesProps {
  projectName?: string;
  roleName?: string;
  lockedEmail?: string;
}

function formatRoleName(roleName: string) {
  return roleName === 'SuperUser' ? 'SuperUser (project manager)' : roleName;
}

export function AuthInviteBadges({
  projectName,
  roleName,
  lockedEmail,
}: AuthInviteBadgesProps) {
  return (
    <>
      {lockedEmail ? (
        <p className="auth-field__hint auth-field__hint--block">
          This invitation is locked to <strong>{lockedEmail}</strong>
        </p>
      ) : null}

      {projectName ? (
        <div className="auth-badge" role="status">
          <span className="auth-badge__label">Project</span>
          <span className="auth-badge__value">{projectName}</span>
        </div>
      ) : null}

      {roleName ? (
        <div className="auth-badge" role="status">
          <span className="auth-badge__label">Role</span>
          <span className="auth-badge__value">{formatRoleName(roleName)}</span>
        </div>
      ) : null}
    </>
  );
}

export default AuthInviteBadges;
